import { useLayoutEffect, useEffect } from 'react';

export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useIdentifiedPage = (className: string) => {
  useEffect(() => {
    const node = document.createElement('div');
    node.className = className;
    node.style.display = 'none';

    document.body.prepend(node);

    return () => node.remove();
  }, []);
};
